import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { parseFactory } from "../../../../validators/parse.js";
import { z } from "zod";
//#region src/central/v2/users/get/by-id.ts
var by_id_exports = /* @__PURE__ */ __exportAll({
	ResponseSchema: () => ResponseSchema,
	parse: () => parse
});
var ResponseSchema = z.object({
	active: z.boolean(),
	address: z.string().nullable(),
	emailVerified: z.boolean(),
	locked: z.boolean(),
	notes: z.string().nullable(),
	passwordResetRequired: z.boolean(),
	passwordResetToken: z.string().nullable(),
	planId: z.string(),
	planName: z.string(),
	userName: z.string(),
	uuid: z.string(),
	venue: z.boolean()
});
var parse = parseFactory(ResponseSchema);
//#endregion
export { by_id_exports };

//# sourceMappingURL=by-id.js.map